import { getServiceId } from "@/api/platform";

export default {
  namespaced: true,
  state: {
    serviceId: null,
    vipId: null
  },
  mutations: {
    SET_serviceId(state, data) {
      state.serviceId = data;
    },
    SET_VIP_ID(state, data) {
      state.vipId = data;
    }
  },
  actions: {
    async getServiceId({ commit }) {
      const { vip_id, cus_id } = await getServiceId();
      commit("SET_serviceId", cus_id);
      commit("SET_VIP_ID", vip_id);
    }
  }
};
